import React from 'react';

const SectionHeader = ({ title }) => {
    return (
        <h1 className="fw-bold" style={{ color: "black"}}>{title}</h1>
    );
};

export default SectionHeader;